function Footer() {
    return (
      <footer className="p-4 bg-gray-800 text-center text-white text-sm">
        &copy; {new Date().getFullYear()} Kable's Mill HOA. All rights reserved.
      </footer>
    );
  }
  export default Footer;
  